import { combineReducers } from 'redux';
import campaignReducer from './campaignReducer';
import headerReducer from './headerReducer';
import engagementReducer from './engagementReducer';
import companyReducer from './companyReducer';
import filterReducer from './filterReducer';
import prescriptionReducer from './prescriptionReducer';
import webMatrixReducer from './webMatrixReducer';
import userReducer from './userReducer';
import adminSettingsReducer from './adminSettingsReducer';
import triggerReducer from './triggerReducer';
import customerSettingsReducer from './customerSettingsReducer';
import partnerReducer from './partnerReducer';
import queriesReducer from './queriesReducer';
import bannerAdCampaignReducer from './bannerAdCampaignReducer';
import customMediaCampaignReducer from './customMediaCampaignReducer';
import emailCampaignReducer from './emailCampaignReducer';
import salesRepCampaignReducer from './salesRepCampaignReducer';
import smsCampaignReducer from './smsCampaignReducer';
import venderIntegrationReducer from './venderIntegrationReducer';
import durationReducer from './durationReducer';
import dataSourcesReducer from './dataSourcesReducer';
import channelReducer from './channelReducer';
import totalEngagement from './totalEngagementReducer';
import fieldEngagement from './fieldEngagementReducer';
import digitalEngagement from './digitalEngagementReducer';
import physicianReducer from './physicianReducer';
import algorithmCampaign from './algorithemCampaignReducer';
import physicianTargetListAnalysisReducer from './physicianTargetListAnalysisReducer';
import affinityHubReducer from './affinityHubReducer';
import filesUploadReducer from './filesUploadReducer';
import creativeUploadReducer from './creativeUploadReducer';
import paidSearchReducer from './paidSearchReducer';

const rootReducer = combineReducers({
    campaign: campaignReducer,
    header: headerReducer,
    engagement: engagementReducer,
    company: companyReducer,
    filter: filterReducer,
    prescription: prescriptionReducer,
    webMatrix: webMatrixReducer,
    user: userReducer,
    adminSettings: adminSettingsReducer,
    trigger: triggerReducer,
    customerSettings: customerSettingsReducer,
    partner: partnerReducer,
    channel: channelReducer,
    query: queriesReducer,    
    bannerAdCampaign: bannerAdCampaignReducer,
    customMediaCampaign: customMediaCampaignReducer,
    emailCampaign: emailCampaignReducer,
    salesRepCampaign: salesRepCampaignReducer,
    smsCampaign: smsCampaignReducer,
    venderIntegration: venderIntegrationReducer,
    duration: durationReducer,
    dataSources: dataSourcesReducer,
    totalEngagement: totalEngagement,
    fieldEngagement: fieldEngagement,
    digitalEngagement: digitalEngagement,
    physician: physicianReducer,
    algorithmCampaign: algorithmCampaign,
    physicianTargetListAnalysis: physicianTargetListAnalysisReducer,
    affinityHub: affinityHubReducer,
    filesUpload: filesUploadReducer,
    creativeUpload: creativeUploadReducer,
    paidSearch: paidSearchReducer
    
});

export default rootReducer;